// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#whiteboard-interface #whiteboardContent #whiteboardCanvas {
  border: 1px solid #000;
  cursor: crosshair;
  background-color: white;
}

#whiteboard-interface #whiteboardContent .resize-handle,
#whiteboard-interface #whiteboardContent .move-handle {
  width: 8px;
  height: 8px;
  background: red;
  position: absolute;
}

#whiteboard-interface #whiteboardContent .move-handle {
  background: blue;
}

#whiteboard-interface #whiteboardContent #textInput {
  display: none;
  position: absolute;
  z-index: 10;
  width: 200px;
}

#whiteboard-interface #whiteboardContent .shape-icon {
  width: 20px;
  height: 20px;
  color: white;
}

#whiteboard-interface #whiteboardContent .toolbar .btn-group button,
#whiteboard-interface #whiteboardContent .toolbar .dropdown-menu a {
  font-size: 0.8rem;
  padding: 5px 10px;
  margin: 0 2px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

#whiteboard-interface #whiteboardContent .toolbar .dropdown-menu a {
  background-color: transparent;
  color: rgb(27, 26, 26);
}

#whiteboard-interface #whiteboardContent .toolbar .btn-group button:hover,
#whiteboard-interface #whiteboardContent .toolbar .dropdown-menu a:hover {
  background-color: #e3e7eb;
}

#whiteboard-interface #whiteboardContent .toolbar .btn-group button.active {
  background-color: #454d55;
}

#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button,
#whiteboard-interface #whiteboardContent .toolbarScreen .dropdown-menu a {
  font-size: 0.8rem;
  padding: 5px 10px;
  margin: 0 2px;
  border-radius: 4px;
  color: "black";
}

#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button {
  background-color: #e3e7eb;
  border: none;
}

#whiteboard-interface #whiteboardContent .toolbarScreen .dropdown-menu a {
  background-color: transparent;
  color: rgb(27, 26, 26);
}

#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button:hover,
#whiteboard-interface #whiteboardContent .toolbarScreen .dropdown-menu a:hover {
  background-color: rgba(214, 209, 209, 0.4);
  color: black;
}

#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button.active {
  background-color: #454d55;
}

#whiteboard-interface #whiteboardContent #toolbarToggleScreen {
  background-color: rgba(214, 209, 209, 0.4);
  border: "1px solid black";
}

#whiteboard-interface #whiteboardContent #toolbar,
#whiteboard-interface #whiteboardContent #toolbarScreen {
  transition: display 0.3s ease-in-out;
}

#whiteboard-interface #whiteboardContent #toolbarToggle,
#whiteboard-interface #whiteboardContent #toolbarToggleScreen {
  cursor: pointer;
}

#whiteboard-interface #whiteboardContent #colorPicker,
#whiteboard-interface #whiteboardContent #colorPickerScreen {
  font-size: 0.8rem;
  padding: 2px 2px;
  width: 32px;
  height: 32px;
}

#whiteboard-interface #whiteboardContent #lineTypePicker {
  font-size: 0.8rem;
  padding: 2px auto;
  width: 32px;
  height: 32px;
}

#whiteboard-interface #whiteboardContent .btnBoard {
  font-size: 1rem;
  padding: 2px 2px;
  width: 40px;
  height: 40px;
  margin: 2px;
}

#whiteboard-interface #whiteboardContent #lineTypePickerScreen {
  font-size: 0.8rem;
  padding: 2px auto;
  width: 32px;
  height: 32px;
  background-color: rgba(214, 209, 209, 0.4);
  color: #000;
}

#whiteboard-interface #whiteboardContent .toggle-icon {
  width: 34px;
  height: 34px;
  padding: 0;
  margin: 0;
}

#whiteboard-interface #whiteboardContent #toggleBackground.active {
  background-color: #fdfeff;
}

#whiteboard-interface #whiteboardContent .annotateScreenBtn {
  background-color: #2d2e2f !important;
  border: 2px solid #000 !important;
  color: green !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/whiteboardComponents/Whiteboard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;AACzB","sourcesContent":["#whiteboard-interface #whiteboardContent #whiteboardCanvas {\r\n  border: 1px solid #000;\r\n  cursor: crosshair;\r\n  background-color: white;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .resize-handle,\r\n#whiteboard-interface #whiteboardContent .move-handle {\r\n  width: 8px;\r\n  height: 8px;\r\n  background: red;\r\n  position: absolute;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .move-handle {\r\n  background: blue;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #textInput {\r\n  display: none;\r\n  position: absolute;\r\n  z-index: 10;\r\n  width: 200px;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .shape-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: white;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbar .btn-group button,\r\n#whiteboard-interface #whiteboardContent .toolbar .dropdown-menu a {\r\n  font-size: 0.8rem;\r\n  padding: 5px 10px;\r\n  margin: 0 2px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbar .dropdown-menu a {\r\n  background-color: transparent;\r\n  color: rgb(27, 26, 26);\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbar .btn-group button:hover,\r\n#whiteboard-interface #whiteboardContent .toolbar .dropdown-menu a:hover {\r\n  background-color: #e3e7eb;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbar .btn-group button.active {\r\n  background-color: #454d55;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button,\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .dropdown-menu a {\r\n  font-size: 0.8rem;\r\n  padding: 5px 10px;\r\n  margin: 0 2px;\r\n  border-radius: 4px;\r\n  color: \"black\";\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button {\r\n  background-color: #e3e7eb;\r\n  border: none;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .dropdown-menu a {\r\n  background-color: transparent;\r\n  color: rgb(27, 26, 26);\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button:hover,\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .dropdown-menu a:hover {\r\n  background-color: rgba(214, 209, 209, 0.4);\r\n  color: black;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toolbarScreen .btn-group button.active {\r\n  background-color: #454d55;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #toolbarToggleScreen {\r\n  background-color: rgba(214, 209, 209, 0.4);\r\n  border: \"1px solid black\";\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #toolbar,\r\n#whiteboard-interface #whiteboardContent #toolbarScreen {\r\n  transition: display 0.3s ease-in-out;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #toolbarToggle,\r\n#whiteboard-interface #whiteboardContent #toolbarToggleScreen {\r\n  cursor: pointer;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #colorPicker,\r\n#whiteboard-interface #whiteboardContent #colorPickerScreen {\r\n  font-size: 0.8rem;\r\n  padding: 2px 2px;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #lineTypePicker {\r\n  font-size: 0.8rem;\r\n  padding: 2px auto;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .btnBoard {\r\n  font-size: 1rem;\r\n  padding: 2px 2px;\r\n  width: 40px;\r\n  height: 40px;\r\n  margin: 2px;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #lineTypePickerScreen {\r\n  font-size: 0.8rem;\r\n  padding: 2px auto;\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: rgba(214, 209, 209, 0.4);\r\n  color: #000;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .toggle-icon {\r\n  width: 34px;\r\n  height: 34px;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent #toggleBackground.active {\r\n  background-color: #fdfeff;\r\n}\r\n\r\n#whiteboard-interface #whiteboardContent .annotateScreenBtn {\r\n  background-color: #2d2e2f !important;\r\n  border: 2px solid #000 !important;\r\n  color: green !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
